var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogoCute(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 120,
    height: 140,
    viewBox: "0 0 120 140",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Animation placeholder"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Shape",
    d: "M47.6816 0H120V92.1854H47.6816V0Z",
    fill: "#FFDF0A"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape (Stroke)",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M116 4H51.6816V88.1854H116V4ZM47.6816 0V92.1854H120V0H47.6816Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape_2",
    d: "M38.1465 9.5365H110.464V101.722H38.1465V9.5365Z",
    fill: "#FFDF0A"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape (Stroke)_2",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M106.464 13.5365H42.1465V97.7219H106.464V13.5365ZM38.1465 9.5365V101.722H110.464V9.5365H38.1465Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape_3",
    d: "M28.6094 19.073H100.927V111.258H28.6094V19.073Z",
    fill: "#FFDF0A"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape (Stroke)_3",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M96.9273 23.073H32.6094V107.258H96.9273V23.073ZM28.6094 19.073V111.258H100.927V19.073H28.6094Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape_4",
    d: "M19.0723 28.6091H91.3901V120.795H19.0723V28.6091Z",
    fill: "#FFDF0A"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape (Stroke)_4",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M87.3901 32.6091H23.0723V116.795H87.3901V32.6091ZM19.0723 28.6091V120.795H91.3901V28.6091H19.0723Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape_5",
    d: "M9.53711 38.1456H81.855V130.331H9.53711V38.1456Z",
    fill: "#FFDF0A"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape (Stroke)_5",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M77.855 42.1456H13.5371V126.331H77.855V42.1456ZM9.53711 38.1456V130.331H81.855V38.1456H9.53711Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape_6",
    d: "M0 47.6821H72.3179V139.868H0V47.6821Z",
    fill: "#FFDF0A"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape (Stroke)_6",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M68.3179 51.6821H4V135.868H68.3179V51.6821ZM0 47.6821V139.868H72.3179V47.6821H0Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    id: "face",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M30 76C30 79.3137 27.3137 82 24 82C20.6863 82 18 79.3137 18 76C18 72.6863 20.6863 70 24 70C27.3137 70 30 72.6863 30 76ZM53 76C53 79.3137 50.3137 82 47 82C43.6863 82 41 79.3137 41 76C41 72.6863 43.6863 70 47 70C50.3137 70 53 72.6863 53 76ZM32.4743 89.577C31.6884 89.315 30.8389 89.7397 30.577 90.5257C30.315 91.3116 30.7397 92.1611 31.5257 92.423L42.7251 96.1562L34.4231 99.6154L31.1 101L34.4231 102.385L42.7251 105.844L31.5257 109.577C30.7397 109.839 30.315 110.688 30.577 111.474C30.8389 112.26 31.6884 112.685 32.4743 112.423L44.9407 108.268C47.1333 107.537 47.2451 104.477 45.1116 103.588L38.9 101L45.1116 98.4118C47.2451 97.5229 47.1333 94.4633 44.9407 93.7324L32.4743 89.577Z",
    fill: "black"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoCute);
export default __webpack_public_path__ + "static/media/logo-cute.a48c634aa8336463e76fa0eff23ae7d7.svg";
export { ForwardRef as ReactComponent };